import React from "react";
import PropTypes from "prop-types";
import MessageContainer from "../MessageContainer";
import { ReactComponent as DocumentSvg } from "../../../../assets/chat/nda-document.svg";
import Button from "../../Button";

const _prefix = "chat-tendering__quotation-sent";

const ScheduleSent = ({ quotationId }) => {
  const handleViewClick = () => {};

  return (
    <MessageContainer alignment={"center"}>
      <div className={_prefix}>
        <span>Master Schedule has been sent</span>
        <Button
          label={"Download Schedule"}
          size="small"
          onClick={handleViewClick}
        />
      </div>
    </MessageContainer>
  );
};

ScheduleSent.propTypes = {};

export default ScheduleSent;
